import template from './sw-cms-preview-product-listing.html.twig';
import './sw-cms-preview-product-listing.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
